import constant from "@/utils/constant";
import { Grid2, styled } from "@mui/material";

const sectionSpacing = constant.GRID_SECTION_SPACING;

export const Styled = {
    Section: styled(Grid2)`
        border-top: 1px solid #ddd;
        padding-top: ${props => props.theme.spacing(sectionSpacing)};
    `,
    Card: styled(Grid2)`
        margin-top: ${props => props.theme.spacing(sectionSpacing)};
    `,
};
